export default __webpack_public_path__ + "static/media/klima2.0b0a9e7d.jpg";